module.exports = __webpack_public_path__ + "img/a5.8b7fc19f.jpg";